import React from "react";
import { styled } from "@mui/styles";
import Calendar from "react-calendar";
import { useTheme } from "@emotion/react";
import {
  useRecoilRefresher_UNSTABLE,
  useRecoilState,
  useRecoilValue,
  useResetRecoilState,
  useSetRecoilState,
} from "recoil";
import {
  daysAvailableState,
  hoursAvailableFetchState,
  hoursAvailableState,
  loadingDaysCalendarState,
  professionalsMatchCovenantState,
  professionalsNoMatchCovenantState,
} from "../../state/atoms";
import { calendarState, dayDefaultAvailableState } from "./state/atoms";
import { useMediaQuery } from "@mui/material";
import CalendarVerticalSkeleton from "../../../shared/components/skeletons/CalendarVerticalSkeleton";
import { memo } from "react";
import useSearchHours from "src/SearchHours/hooks/useSearchHours";
import { agendamientoInconclusoState } from "src/ResultSearch/state/atoms";

const StyledCalendar = styled((props) => <Calendar {...props} />)(
  ({ theme }) => ({
    position: "sticky",
    top: 70,
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
    backgroundColor: "transparent",
    border: "none",
    fontFamily: "Montserrat",
    "& .react-calendar__navigation__label": {
      fontFamily: "Montserrat",
      fontSize: "1rem",
      fontWeight: "bold",
    },
    "& .react-calendar__navigation__label[disabled]": {
      backgroundColor: "transparent",
      color: "black",
    },
    "& .react-calendar__navigation button[disabled]": {
      backgroundColor: "transparent",
    },
    "& button": {
      fontFamily: "Montserrat",
    },
    "& .react-calendar__tile--active": {
      borderRadius: "100%",
    },
  })
);

const CalendarVertical = memo(() => {
  const optionsDefault = {
    next2Label: null,
    prev2Label: null,
    minDetail: "month",
    maxDetail: "month",
    defaultView: "month",
  };

  const theme = useTheme();

  const daysAvailable = useRecoilValue(daysAvailableState);
  const [calendar, setCalendar] = useRecoilState(calendarState);
  const [dayDefaultAvailable, setDayDefaultAvailable] = useRecoilState(
    dayDefaultAvailableState
  );
  const isMediaScreen = useMediaQuery(theme.breakpoints.down("md"));
  const loadingDaysCalendar = useRecoilValue(loadingDaysCalendarState);
  const resetHoursAvailable = useResetRecoilState(hoursAvailableState);
  const resetHrofessionalsMatchCovenant = useResetRecoilState(
    professionalsMatchCovenantState
  );
  const resetHrofessionalsNoMatchCovenant = useResetRecoilState(
    professionalsNoMatchCovenantState
  );
  const refreshHours = useRecoilRefresher_UNSTABLE(hoursAvailableFetchState);
  const { loadHoursAvailable } = useSearchHours();
  const setValueAgendamientoInconcluso = useSetRecoilState(
    agendamientoInconclusoState
  );

  //if (daysAvailable.length === 0) return <CalendarEmpty />
  if (isMediaScreen) return null;
  if (loadingDaysCalendar) return <CalendarVerticalSkeleton />;

  return (
    <StyledCalendar
      theme={theme}
      {...optionsDefault}
      onChange={(value) => {
        setValueAgendamientoInconcluso((prev) => ({
          ...prev,
          agiFechaBuscada: value,
        }));
        setDayDefaultAvailable(value);
        resetHoursAvailable();
        resetHrofessionalsMatchCovenant();
        resetHrofessionalsNoMatchCovenant();
        if (
          value.toISOString().split("T")[0] ===
          new Date().toISOString().split("T")[0]
        ) {
          setTimeout(() => {
            refreshHours();
            // loadHoursAvailable()
          }, 0);
        }
        setCalendar({
          ...calendar,
          value,
        });
      }}
      value={dayDefaultAvailable}
      minDate={calendar.minDate}
      tileClassName={({ date }) => {
        return daysAvailable &&
          daysAvailable.find(
            (x) =>
              new Date(x.ageInicio).getDate() === date.getDate() &&
              new Date(x.ageInicio).getMonth() + 1 === date.getMonth() + 1 &&
              new Date(x.ageInicio).getFullYear() === date.getFullYear()
          )
          ? "react-calendar__tile--dayAvailable"
          : null;
      }}
      tileDisabled={({ date }) => {
        return (
          daysAvailable &&
          !daysAvailable.find(
            (x) =>
              new Date(x.ageInicio).getDate() === date.getDate() &&
              new Date(x.ageInicio).getMonth() + 1 === date.getMonth() + 1 &&
              new Date(x.ageInicio).getFullYear() === date.getFullYear()
          )
        );
      }}
    />
  );
});

export default CalendarVertical;
